export default "__VITE_ASSET__6Q1vj7Bw__"